import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Grid, IconButton, makeStyles, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import AdminTopbar from './AdminTopbar';
import { Add, ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import AdminFooter from './AdminFooter';
import axiosInstance, { WEB_API } from '../common/Constants';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
}));

const ClientListPage = (props) => {
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selectFilter, setSelectFilter] = useState('all');

  let cols = [
    {
      name: 'logo',
      label: 'Logo',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <img src={value.path} alt={value.name} style={{ width: '100px' }} />;
        },
      },
    },
    {
      name: 'title',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'category',
      label: 'Category',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'id',
      label: 'Order',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <IconButton aria-label="delete" size="small" onClick={() => handleOrder('down', value, tableMeta)}>
                <ArrowDropDown />
              </IconButton>
              <IconButton aria-label="delete" size="small" onClick={() => handleOrder('up', value, tableMeta)}>
                <ArrowDropUp />
              </IconButton>
            </div>
          );
        },
      },
    },
    {
      name: 'id',
      label: '삭제',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButton aria-label="delete" size="small" onClick={() => setDeleteAction(value, tableMeta)}>
              <DeleteIcon />
            </IconButton>
          );
        },
      },
    },
  ];

  const handleOrder = (type, value, meta) => {
    const item = data[meta.rowIndex];
    const param = {};
    if (type === 'up') {
      if (meta.rowIndex > 0) {
        param['referId'] = data[meta.rowIndex - 1].id;
        param['referOrder'] = item.sortOrder;
        param['targetId'] = item.id;
        param['targetOrder'] = item.sortOrder - 1;
      }
    } else {
      // down
      if (meta.rowIndex < data.length - 1) {
        param['referId'] = data[meta.rowIndex + 1].id;
        param['referOrder'] = item.sortOrder;
        param['targetId'] = item.id;
        param['targetOrder'] = item.sortOrder + 1;
      }
    }
    if (param.targetId) {
      axiosInstance.put(`${WEB_API}/home/client/sortOrder`, param).then(() => {
        getUserData();
      });
    }
  };

  const setDeleteAction = (value, meta) => {
    swal({
      title: '정말 삭제하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.delete(`${WEB_API}/home/client?clientId=${data[meta.rowIndex].id}`).then((data) => {
          getUserData();
        });
      }
    });
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      const newData = alldata.filter((d) => {
        return d.category === _filter;
      });
      setData(newData);
    }
  };

  const addProject = (id, cate, title, logo) => {
    swal(
      <div>
        <h1>Poster {cate ? '수정' : '추가'}</h1>
        <select
          id={'sel-cate'}
          value={cate || ''}
          style={{ padding: '16px', width: '100%', marginTop: '20px' }}
          onChange={() => console.log('')}
        >
          <option value={''}>{'Category'}</option>
          <option value={'Pharmaceutical'}>{'Pharmaceutical'}</option>
          <option value={'MedicalSociety'}>{'MedicalSociety'}</option>
          <option value={'NoneMedical'}>{'NoneMedical'}</option>
        </select>
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>Name</p>
        <TextField id={'input-title'} margin="dense" fullWidth value={title || ''} />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>Logo</p>
        <input id="logo" type="file" style={{ width: '100%' }} />
        <p style={{ width: '100%', textAlign: 'left', marginTop: '10px' }}>{logo}</p>
      </div>,
    ).then((isOK) => {
      if (isOK) {
        let formdata = new FormData();
        formdata.append('title', document.getElementById('input-title').value);
        formdata.append('category', document.getElementById('sel-cate').value);
        if (document.getElementById('logo').files.length > 0) {
          formdata.append('logo', document.getElementById('logo').files[0]);
        }
        if (id) {
          formdata.append('clientId', id);
          axiosInstance.put(`${WEB_API}/home/client`, formdata).then(() => {
            getUserData();
          });
        } else {
          axiosInstance.post(`${WEB_API}/home/client`, formdata).then(() => {
            getUserData();
          });
        }
      }
    });
  };

  const rowClick = (_data, row) => {
    if (row.colIndex < 3) {
      const item = data[row.dataIndex];
      addProject(item.id, item.category, item.title, item.logo.name);
    } else if (row.colIndex === 4) {
      setDeleteAction(_data, row);
    }
  };

  const options = {
    print: false,
    filterType: 'checkbox',
    viewColumns: false,
    download: false,
    searchOpen: false,
    selectableRows: 'none',
    onCellClick: rowClick,
  };

  const getUserData = () => {
    axiosInstance.get(`${WEB_API}/home/client/list`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      const sort = response.data.Items.sort(function (a, b) {
        return a.sortOrder - b.sortOrder;
      });
      setData(sort);
      setAllData(sort);
    });
  };
  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={2} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justify={'space-between'} alignItems={'center'}>
            <Grid item>
              <h1>Clients</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All
                </Button>
                <Button
                  variant={selectFilter === 'Pharmaceutical' ? 'contained' : 'outlined'}
                  onClick={() => handleFilter('Pharmaceutical')}
                >
                  Pharmaceutical
                </Button>
                <Button
                  variant={selectFilter === 'MedicalSociety' ? 'contained' : 'outlined'}
                  onClick={() => handleFilter('MedicalSociety')}
                >
                  Medical Society
                </Button>
                <Button variant={selectFilter === 'NoneMedical' ? 'contained' : 'outlined'} onClick={() => handleFilter('NoneMedical')}>
                  None Medical
                </Button>
              </ButtonGroup>
            </Grid>
            <Grid item style={{ flex: 1 }}>
              &nbsp;
            </Grid>
            <Grid item>
              <Button variant={'outlined'} onClick={() => addProject()} startIcon={<Add />}>
                New Client
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <MUIDataTable title={''} data={data} columns={cols} options={options} />
        </Grid>
      </Grid>
      <AdminFooter />
    </Grid>
  );
};

export default ClientListPage;
